export default __webpack_public_path__ + "static/media/translator.2fddde8a.svg";